import {AxiosResponse} from 'axios'
import {axiosInstance} from 'src/utils/axios'
import {iamServiceURL} from "../config"
import { PostUserInput, User } from 'src/types/users'

export type PostUser = (body: PostUserInput) => Promise<AxiosResponse<User> | undefined>

export const postUser: PostUser = async (input: PostUserInput) => {
  try {
    const path = '/v3/users'
    const headers = {
      'Content-Type': 'application/json',
    }

    const opts = {
      baseURL: iamServiceURL,
      headers: headers,
    }

    const body = {
      firstName: input.firstName,
      lastName: input.lastName,
      email: input.email,
      orgID: input.orgRole.orgId,
      role: input.orgRole.roles[0],
    }

    return await axiosInstance.post<User>(path, body, opts)
  } catch (error) {
    console.error('Error creating user:', error)
    throw error
  }
}